import jsonLogic, { add_operation } from 'json-logic-js';

export const addedJsonLogicOperators = {
  starts_with: (str: any, substr: any) => `${str}`.startsWith(`${substr}`),
  ends_with: (str: any, substr: any) => `${str}`.endsWith(`${substr}`),
  like: (str: any, regex: any) => RegExp(regex).test(str),
  not_like: (str: any, regex: any) => !RegExp(regex).test(str),
};

export function registerCustomJsonLogicOperators() {
  for (const [key, value] of Object.entries(addedJsonLogicOperators)) {
    add_operation(key, value);
  }
}

registerCustomJsonLogicOperators();

export const ruleJsonLogic = jsonLogic;
